﻿window.dict_electricconnection_type_coef_edit = function () {
    var instance = {
        init: function () {
            im_decimal.mask("#dict_electricconnection_type_coef_edit_k1, #dict_electricconnection_type_coef_edit_k2");
            im_integer.mask("#dict_electricconnection_type_coef_edit_plowerbound, #dict_electricconnection_type_coef_edit_pupperbound");
            $("#dict_electricconnection_type_coef_edit_k1_fieldbody, #dict_electricconnection_type_coef_edit_k2_fieldbody, #dict_electricconnection_type_coef_edit_plowerbound_fieldbody, #dict_electricconnection_type_coef_edit_pupperbound_fieldbody").addClass("r");

            $("#dict_electricconnection_type_coef_edit_electricconnection_type").change(function () {
                var val = $("#dict_electricconnection_type_coef_edit_electricconnection_type option[value=" + $("#dict_electricconnection_type_coef_edit_electricconnection_type").val() + "]").text();
                if (val === "Генерация")
                    $("#dict_electricconnection_type_coef_edit_plowerbound_field, #dict_electricconnection_type_coef_edit_pupperbound_field").show();
                else
                    $("#dict_electricconnection_type_coef_edit_plowerbound_field, #dict_electricconnection_type_coef_edit_pupperbound_field").hide();
            });            
        }
    };
    var im_decimal = Inputmask("decimal", {
        radixPoint: '.',
        inputtype: "text",
        digits: 3,
        allowMinus: false
    });
    var im_integer = Inputmask("integer", {
        inputtype: "text",
        allowMinus: false
    });
    return instance;
}();